import styled, { CSSProperties } from 'styled-components'

export interface FlexContainerProps
  extends Pick<CSSProperties, 'alignItems' | 'alignSelf' | 'flex' | 'height'> {
  justify?: CSSProperties['justifyContent']
  direction?: CSSProperties['flexDirection']
  noWrap?: boolean
  full?: boolean
  gap?: number
}

export const FlexContainer = styled.div<FlexContainerProps>`
  display: flex;
  flex-wrap: ${props => (props.noWrap ? 'nowrap' : 'wrap')};
  align-items: ${props => (props.alignItems ? props.alignItems : 'center')};
  align-self: ${props => props.alignSelf};
  justify-content: ${props => (props.justify ? props.justify : 'space-between')};
  flex-direction: ${props => (props.direction ? props.direction : 'row')};
  flex: ${props => (props.flex ? props.flex : 1)};
  width: ${props => (props.full ? '100%' : 'auto')};
  height: ${({ height }) => height};
  gap: ${({ gap }) => (gap ? `${gap}px` : 'unset')};
`
